import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.AUDIT_CONTROLLER_GET_SUCCESS:
        case actionTypes.AUDIT_CONTROLLER_SET: {
            const { auditControllers } = action.payload;
            return helpers.getListReducer(state, auditControllers);
        }
        case actionTypes.AUDIT_CONTROLLER_MERGE: {
            const { auditControllers } = action.payload;
            return { ...state, item: null };
        }
        case actionTypes.AUDIT_CONTROLLER_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.AUDIT_CONTROLLER_GET_REQUEST: {
            return getInitialState.list();
        }

        case actionTypes.AUDIT_CONTROLLER_ITEM_SET: {
            const { auditControllers } = action.payload;
            return { ...state, item: auditControllers };
        }
        case actionTypes.AUDIT_CONTROLLER_POST_SUCCESS: {
            return state;
        }
        case actionTypes.AUDIT_CONTROLLER_UPDATE_ASSET: {
            const { auditController } = action.payload;
            const updatedData = helpers.mergeWithListData(
                state.data,
                auditController
            );
            return { ...state, data: updatedData };
        }

        default: {
            return state;
        }
    }
}
